"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalModal_styled_exports = {};
__export(GlobalModal_styled_exports, {
  StyledButtonContainer: () => StyledButtonContainer,
  StyledContent: () => StyledContent,
  StyledCustomHeader: () => StyledCustomHeader,
  StyledFooter: () => StyledFooter,
  StyledModal: () => StyledModal,
  StyledModalHeader: () => StyledModalHeader,
  StyledModalTitle: () => StyledModalTitle,
  modalWidths: () => modalWidths
});
module.exports = __toCommonJS(GlobalModal_styled_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react_modal = __toESM(require("react-modal"));
var import_Icon = require("../../atoms/Icon/Icon.styled");
var import_Heading = require("../../atoms/Heading/Heading.styled");
var import_mixins = require("../../../themes/mixins");
var modalWidths = {
  "default": "808px",
  large: "1032px",
  "x-large": "1318px",
  "full-screen": "100%"
};
var isFullScreen = function isFullScreen2(size) {
  return size === "full-screen";
};
var StyledModal = (0, import_styled_components.default)(import_react_modal.default).withConfig({
  displayName: "GlobalModalstyled__StyledModal",
  componentId: "sc-1up40wc-0"
})(function(_ref) {
  var theme = _ref.theme, size = _ref.size, maxHeight = _ref.maxHeight, maxWidth = _ref.maxWidth;
  return (0, import_styled_components.css)(["background-color:", ";box-sizing:border-box;display:flex;flex-direction:column;max-height:", ";max-width:", ";overflow-y:auto;padding:0px;width:", ";margin:0 8px;height:", ";", " ", " ", ";", ";"], theme.colors.white, isFullScreen(size) ? modalWidths["full-screen"] : maxHeight || "95%", maxWidth, isFullScreen(size) ? modalWidths["full-screen"] : "486px", isFullScreen(size) ? modalWidths["full-screen"] : "", (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["width:", ";"], isFullScreen(size) ? modalWidths["full-screen"] : "648px")), (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["width:", ";"], size ? modalWidths[size] : "808px")), (0, import_mixins.withStyledScrollBar)(), (0, import_mixins.withBorderRadius)(theme.measurements.small));
});
var StyledModalTitle = import_styled_components.default.div.withConfig({
  displayName: "GlobalModalstyled__StyledModalTitle",
  componentId: "sc-1up40wc-1"
})(function(_ref2) {
  var theme = _ref2.theme;
  return (0, import_styled_components.css)(["align-items:center;display:flex;", "{color:", ";display:inline-block;font-family:", ";font-size:", ";font-weight:", ";line-height:24px;margin:", ";}", "{color:", ";font-weight:", ";margin-right:", ";padding:3px;}"], import_Heading.StyledH1, theme.colors.black, theme.typography.fonts.primary, theme.typography.sizes.extraLarge, theme.typography.weights.regular, theme.measurements.zero, import_Icon.StyledIcon, theme.colors.primary[0], theme.typography.weights.regular, theme.measurements.small);
});
var StyledModalHeader = import_styled_components.default.div.withConfig({
  displayName: "GlobalModalstyled__StyledModalHeader",
  componentId: "sc-1up40wc-2"
})(function(_ref3) {
  var hideBars = _ref3.hideBars, theme = _ref3.theme;
  return (0, import_styled_components.css)(["align-items:center;box-sizing:border-box;display:flex;justify-content:space-between;width:100%;border-bottom:", ";", ";"], hideBars ? "none" : "".concat(theme.measurements.extraExtraSmall, " solid ").concat(theme.colors.beige[180]), (0, import_mixins.withPadding)("extraExtraLarge"));
});
var StyledCustomHeader = import_styled_components.default.div.withConfig({
  displayName: "GlobalModalstyled__StyledCustomHeader",
  componentId: "sc-1up40wc-3"
})(function(_ref4) {
  var theme = _ref4.theme, _ref4$padding = _ref4.padding, padding = _ref4$padding === void 0 ? "0px" : _ref4$padding;
  return (0, import_styled_components.css)(["display:flex;flex-direction:row;flex-grow:1;font-family:", ";font-size:", ";font-weight:", ";justify-content:center;padding:", ";position:relative;"], theme.typography.fonts.primary, theme.typography.sizes.medium, theme.typography.weights.regular, "20px ".concat(padding, " 4px ").concat(padding) || "46px 80px");
});
var StyledContent = import_styled_components.default.div.withConfig({
  displayName: "GlobalModalstyled__StyledContent",
  componentId: "sc-1up40wc-4"
})(function(_ref5) {
  var theme = _ref5.theme, padding = _ref5.padding, withCustomHeader = _ref5.withCustomHeader;
  return (0, import_styled_components.css)(["box-sizing:border-box;flex-grow:1;font-family:", ";font-size:", ";font-weight:", ";line-height:24px;padding-top:", ";padding:", ";width:100%;", " ", ""], theme.typography.fonts.primary, theme.typography.sizes.medium, theme.typography.weights.regular, withCustomHeader ? "0px" : padding, padding || "16px 24px", (0, import_mixins.mediaBreakpointUp)("md", (0, import_styled_components.css)(["padding:", ";"], padding || "24px 40px")), (0, import_mixins.mediaBreakpointUp)("lg", (0, import_styled_components.css)(["padding:", ";overflow-y:auto;", ""], padding || "48px 80px", (0, import_mixins.withStyledScrollBar)())));
});
var StyledFooter = import_styled_components.default.div.withConfig({
  displayName: "GlobalModalstyled__StyledFooter",
  componentId: "sc-1up40wc-5"
})(function(_ref6) {
  var theme = _ref6.theme, hideBars = _ref6.hideBars;
  return (0, import_styled_components.css)(["box-sizing:border-box;display:flex;flex-direction:column;font-family:", ";justify-content:flex-end;padding:16px 0;width:100%;border-top:", ";", ""], theme.typography.fonts.primary, hideBars ? "none" : "".concat(theme.measurements.extraExtraSmall, " solid ").concat(theme.colors.beige[180]), (0, import_mixins.mediaBreakpointUp)("md", "\n      flex-direction: row;\n      padding: 16px;\n    "));
});
var StyledButtonContainer = import_styled_components.default.div.withConfig({
  displayName: "GlobalModalstyled__StyledButtonContainer",
  componentId: "sc-1up40wc-6"
})(function(_ref7) {
  var withCustomHeader = _ref7.withCustomHeader, _ref7$padding = _ref7.padding, padding = _ref7$padding === void 0 ? "0px" : _ref7$padding;
  return (0, import_styled_components.css)(["position:", ";right:", ";top:", ";"], withCustomHeader ? "absolute" : "", padding, padding);
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  StyledButtonContainer,
  StyledContent,
  StyledCustomHeader,
  StyledFooter,
  StyledModal,
  StyledModalHeader,
  StyledModalTitle,
  modalWidths
});
//# sourceMappingURL=GlobalModal.styled.js.map